import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PayumoneyPaymentService } from 'src/app/core/services/payumoney-payment.service';

@Component({
  selector: 'app-payment-failure',
  templateUrl: './payment-failure.component.html',
  styleUrls: ['./payment-failure.component.scss']
})
export class PaymentFailureComponent implements OnInit {

  constructor(public payumoneyPaymentService:PayumoneyPaymentService,
    public router:Router) { }

  ngOnInit(): void {

    this.getPayment();
this.postPayment()
  }
  getPayment(){
    this.payumoneyPaymentService.getPaymentSuccess({}).then((res)=>{
  this.router.navigate(['/auth/payment-failure'])
    })
    
  
  }
  postPayment(){
    this.payumoneyPaymentService.postPaymentSuccess({}).then((res)=>{
  this.router.navigate(['/auth/payment-failure'])
    })
   
  }

}
